// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import WidgetClassFaqResourceViewModel from '../../../../viewModel/resource/WidgetClassFaqResourceViewModel';
import WidgetClassInformationResourceViewModel from '../../../../viewModel/resource/WidgetClassInformationResourceViewModel';
import WidgetClassInformationResourceDTO from '../../dto/resource/WidgetClassInformationResourceDTO';

export default abstract class WidgetClassInformationResourceModel extends BaseModel<WidgetClassInformationResourceDTO> {
  /**
  */
  get classTypeKey() { return this.dto.classTypeKey; }
  set classTypeKey(value) { this.dto.classTypeKey = value; }
  /**
  */
  get title() { return this.dto.title; }
  set title(value) { this.dto.title = value; }
  /**
  */
  get subtitle() { return this.dto.subtitle; }
  set subtitle(value) { this.dto.subtitle = value; }
  /**
  */
  get wordSubtitle() { return this.dto.wordSubtitle; }
  /**
  */
  get summary() { return this.dto.summary; }
  set summary(value) { this.dto.summary = value; }
  /**
  */
  get faq() { return this.getArrayModels(() => this.dto.faq, WidgetClassFaqResourceViewModel)!; }
  set faq(value) { this.setArrayModels(() => this.dto.faq, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.classTypeKey = qs.classtypekey;
    this.dto.title = qs.title;
    this.dto.summary = qs.summary;
  }
}
